import { toast } from 'react-toastify';
import { createTicketFun, searchCountFun, sendEmail, supInfoFun } from '../../../api/supportAPI';
import errorHandle from '../../../utils/errorHandle';

export const getSupportInfo = (type, phoneNumber, setTableData, setLoading, limit = 10, offset = 0) => {
    setLoading(true);
    const phoneRegex = /^[0-9]*$/;
    try {
        if (!type) {
            toast.error('Please select search type');
            setLoading(false);
        } else if (!phoneNumber) {
            toast.error('Please enter phone number to search');
            setLoading(false);
        } else if (!phoneRegex.test(phoneNumber)) {
            toast.error('Please enter valid phone number');
            setLoading(false);
        } else {
            console.log(limit, offset);
            supInfoFun(type, phoneNumber, limit, offset)
                .then((res) => {
                    if (res.status === 200) {
                        setTableData(res.data);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    console.log('API ERROR:', error);

                    if (error.response?.status === 404) {
                        toast.error(error.response.data?.message);
                        setTableData([]);
                    } else {
                        toast.error(error.response?.data?.message || 'Something went wrong');
                    }
                    setLoading(false);
                });
        }
    } catch (err) {
        setLoading(false);
        errorHandle(err);
    }
};

export const submitTicket = (type, data, setLoading, setModal, setTicketComment) => {
    setLoading(true);
    try {
        if (data.description === '') {
            toast.error('Please enter comment');
            setLoading(false);
        } else {
            createTicketFun(type, data).then((res) => {
                if (res.status === 200) {
                    console.log(res);
                    toast.success('Ticket created successfully');
                    setModal(false);
                    setTicketComment('');
                }
                setLoading(false);
            });
        }
    } catch (err) {
        setLoading(false);
        errorHandle(err);
    }
};

export const sendMessage = (type, bookingId, setLoading) => {
    try {
        sendEmail(type, bookingId).then((res) => {
            toast.success(res.data.message);
            setLoading(false);
        });
    } catch (err) {
        setLoading(false);
        errorHandle(err);
    }
};

export const searchCount = (setTotalCount, type, phoneNumber, setLoading) => {
    try {
        searchCountFun(type, phoneNumber).then((res) => {
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
